import { useLayoutEffect, useRef, useState } from "react";
import { motion, useMotionValue } from "framer-motion";

// تمرير عمودي ناعم بالسحب مع ارتداد زنبركي (rubber-band)، بلا أي حركة أفقية،
// ويعمل بعجلة الماوس على سطح المكتب. العرض ديناميكي كامل بعرض الحاوية.
export const DocScroll = ({ children }) => {
  const viewport = useRef(null);
  const content = useRef(null);
  const [maxUp, setMaxUp] = useState(0);
  const y = useMotionValue(0);

  useLayoutEffect(() => {
    const measure = () => {
      const vh = viewport.current?.clientHeight || 0;
      const ch = content.current?.scrollHeight || 0;
      const m = Math.max(0, ch - vh);
      setMaxUp(m);
      if (y.get() < -m) y.set(-m);
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (content.current) ro.observe(content.current);
    if (viewport.current) ro.observe(viewport.current);
    return () => ro.disconnect();
  }, [y]);

  const onWheel = (e) => y.set(Math.min(0, Math.max(-maxUp, y.get() - e.deltaY)));

  return (
    <div ref={viewport} className="absolute inset-0 overflow-hidden" onWheel={onWheel}>
      <motion.div
        ref={content}
        style={{ y }}
        drag="y"
        dragConstraints={{ top: -maxUp, bottom: 0 }}
        dragElastic={0.18}
        dragTransition={{ bounceStiffness: 320, bounceDamping: 32 }}
        className="!touch-none flex w-full flex-col items-center gap-4 px-3 pb-12 pt-[calc(env(safe-area-inset-top)+5rem)]"
      >
        {children}
      </motion.div>
    </div>
  );
};
